<textarea
rows="10"
nz-input
#textarea
></textarea>
